import { useEffect, useRef } from 'react'
import GLightbox from 'glightbox'
import FloorplanControls from './floorplanControls.jsx'

export default function Floorplans({ floorplanState, setFloorplanState, planTypeOptions }) {
  const planImageRef = useRef(null)
  const lightboxRef = useRef(null)

  useEffect(() => {
    const image = floorplanState.currentPlan?.plan_image

    if (!image) {
      return undefined
    }

    lightboxRef.current = GLightbox({
      elements: [
        {
          href: image,
          type: 'image',
          title: floorplanState.currentPlan?.title ? 'Plan ' + floorplanState.currentPlan?.title : ''
        }
      ]
    })

    return () => {
      lightboxRef.current?.destroy()
      lightboxRef.current = null
    }
  }, [floorplanState.currentPlan])

  useEffect(() => {
    if (window.innerWidth >= 768) {
      return
    }

    const container = planImageRef.current

    if (!container) {
      return
    }

    const img = container.querySelector('img')

    if (!img) {
      return
    }

    const centerScroll = () => {
      container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2
    }

    if (img.complete) {
      centerScroll()
    } else {
      img.addEventListener('load', centerScroll, { once: true })
    }
  }, [floorplanState.currentPlan])

  const handlePlanImageClick = () => {
    lightboxRef.current?.open()
  }

  return (
    <div className="floorplan-area">
      <FloorplanControls
        floorplanState={floorplanState}
        setFloorplanState={setFloorplanState}
        planTypeOptions={planTypeOptions}
      />
      <div className="floorplan-view">
        {floorplanState.currentPlan && (
          <>
            <div className="plan-details">
              <div className="plan-name">
                {floorplanState.currentPlan.title}
                <div className="plan-name-diagonal"></div>
              </div>
              <div className="plan-rooms">
                {floorplanState.currentPlan.plan_type.label}<br className="d-none d-md-block" />
                <span className="d-md-none">, </span>
                {floorplanState.currentPlan.number_of_bathrooms} Bathrooms
              </div>
              <div className="plan-size">
                {floorplanState.currentPlan.plan_collection ? (
                  <>
                    {floorplanState.currentPlan.plan_collection}: <span className="area-range">{floorplanState.currentPlan.area_range}</span>
                  </>
                ) : (
                  <>
                    <span className="area-range">{floorplanState.currentPlan.area_range}</span>
                  </>
                )}
              </div>
            </div>
            <div className="plan-image" ref={planImageRef}>
              <img
                src={floorplanState.currentPlan.plan_image}
                alt={`Plan ${floorplanState.currentPlan.title}`}
                onClick={handlePlanImageClick}
              />
            </div>
            {floorplanState.currentPlan.plan_pdf && (
              <div className="plan-pdf">
                <a className="btn btn-outline-primary" href={floorplanState.currentPlan.plan_pdf} target="_blank" rel="noopener noreferrer">
                  Download Plan
                </a>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}